var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-menu"},[_c('ul',{staticClass:"c-float"},[_c('li',{class:{ active: _vm.get_active_filter_name ===  'All'},on:{"click":function($event){return _vm.changeFilter({
        name: 'All',
      })}}},[_vm._v(" "+_vm._s(_vm.$t('all'))+" ")]),_vm._l((_vm.get_filters_menu),function(menuItem,index){return _c('li',{key:`filterMenuItem-${index}`,class:{ active: _vm.get_active_filter_name ===  menuItem.name},on:{"click":function($event){return _vm.changeFilter({
        name: menuItem.name,
        params: menuItem.params,
      })}}},[_vm._v(" "+_vm._s(menuItem.name)+" ")])}),_c('li',{staticClass:"pointer",on:{"click":_vm.createNewFilter}},[_vm._v("+ "+_vm._s(_vm.$t('Create New')))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }